import {
  Box,
  ButtonBase,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import Progress from '../../../global/ProgressBar';
import useGetOnboarding from '../../../../hooks/businesses/useGetOnboarding';
import { OnboardingModalCategory } from '../../../../types/businesses';

interface Props {
  sx?: SxProps<Theme>;
  onOpenModal: (category: OnboardingModalCategory) => void;
}

function MinOnboardingProgress({ sx, onOpenModal }: Props) {
  const theme = useTheme();
  const { percentCompleted } = useGetOnboarding();

  return (
    <ButtonBase
      onClick={() => onOpenModal('SETUP')}
      disableRipple
      sx={{
        overflow: 'hidden',
        boxSizing: 'border-box',
        py: 2.5,
        ':hover': {
          backgroundColor: 'transparent',
        },
        ...(typeof sx === 'function' ? sx(theme) : sx),
      }}>
      <Box
        width="100%"
        boxSizing="border-box"
        display="flex"
        flexDirection={{
          xs: 'column',
          sm: 'row',
        }}
        justifyContent={{
          xs: 'center',
          sm: 'space-between',
        }}
        alignItems={{
          xs: 'stretch',
          sm: 'center',
        }}
        gap={{
          xs: 1,
          sm: 2.5,
        }}>
        <Typography
          variant="h1"
          component="p"
          fontWeight="bold"
          fontFamily={theme.typography.fontFamily}>
          You&apos;re {percentCompleted}% set up
        </Typography>

        <Box
          boxSizing="border-box"
          flex={1}
          maxWidth={{
            xs: '100%',
            sm: '33%',
            lg: '25%',
          }}
          display="flex"
          alignItems="center"
          gap={1}>
          <Progress progress={percentCompleted} includePercentage />
          <EastRoundedIcon
            htmlColor={theme.palette.secondary.main}
            sx={{
              width: '22px',
            }}
          />
        </Box>
      </Box>
    </ButtonBase>
  );
}

export default MinOnboardingProgress;
